export default function setupSliceGui({ gui, uniforms })
{
  const folder = gui.addFolder('Slice')

  folder.add(uniforms.uSliceStart, 'value', -Math.PI, Math.PI, 0.001).name('uSliceStart')
  folder.add(uniforms.uSliceArc, 'value', 0, Math.PI * 2, 0.001).name('uSliceArc')

  // start closed
  folder.close()

  return folder
}
